import React, { useRef, useState } from "react";

import Buttons from "../../components/ui/button/Buttons";

import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";

const CertificateGroupingListApprove = () => {

  const SGBP009options = [
    { value: "1", label: "CP10- XXXXXXXXXXX" },
    { value: "2", label: "CP9 - YYYYYYYYYYY" },
    { value: "3", label: "CP5 - YYYYYYYYYYY" },
    { value: "4", label: "CP10- XXXXXXXXXXX" },
    { value: "5", label: "CP7 - LLLLLLLLLLL" },
    { value: "6", label: "CP811- XXXXXXXXX" }
  ];

  const BrandAOptions = [
    { value: "1", label: "CP10- XXXXXXXXXXX" },
    { value: "2", label: "CP9 - YYYYYYYYYYY" },
    { value: "3", label: "CP5 - YYYYYYYYYYY" },
    { value: "4", label: "CP10- XXXXXXXXXXX" },
    { value: "5", label: "CP7 - LLLLLLLLLLL" },
    { value: "6", label: "CP811- XXXXXXXXX" }
  ];


  const UserOption = [
    { value: "1", label: "User 1" },
    { value: "2", label: "User 2" },
    { value: "3", label: "User 3" },
   
  ];
  return (
    <div className="certificate-grouping-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <div className="table-title mt-2">
            <h3>Model Grouping</h3>
          </div>
          <div className="member-list">
            <div className="content-section">
              {/* Left Table */}
              <div className="table-section">
                <table>
                  <thead>
                    <tr>
                      <th>Brand Name</th>
                      <th>Model Name</th>
                      <th>Rating</th>
                      <th>Test Value</th>
                      <th>Cert Number</th>
                      <th>Cert Prefix</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Brand Name A</td>
                      <td>Model Name A</td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Name A</td>
                      <td>Model Name A</td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Name A</td>
                      <td>Model Name A</td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Name A</td>
                      <td>Model Name A</td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"

                          // value={poNumber}
                          // onChange={(e) => setPoNumber(e.target.value)}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="table-title mt-4">
            <h3>Cost Allocation</h3>
          </div>
          <div className="cost-allocation-list member-list">
            <div className="content-section">
              {/* Left Table */}
              <div className="table-section">
                <table>
                  <thead>
                    <tr>
                      <th>Cert Number</th>
                      <th>Item Code</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>SGBP009</td>

                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            // value={props.value}
                            // value={""} /
                            options={SGBP009options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={props.isDropdownDisabled}
                          />

                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Name A</td>

                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            // value={props.value}
                            // value={""} /
                            options={BrandAOptions}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={props.isDropdownDisabled}
                          />

                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Name A</td>

                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            // value={props.value}
                            // value={""} /
                            options={SGBP009options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={props.isDropdownDisabled}
                          />

                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="table-title mt-5 mb-4">
            <h3>Internal Notes</h3>
          </div>
          <div className="mt-2">
            <label className="form-label">Comments from Case Officer</label>
            <textarea
              className="form-control mt-1"
              rows="4"
            // value={internalNotes}
            // onChange={(e) => setInternalNotes(e.target.value)}
            ></textarea>
          </div>
          <div className="table-title mt-5 mb-4">
            <h3>Assign to</h3>
          </div>
          <div className="dropdown-select-wrapper">
            <div className="d-flex align-items-center mb-4">
              <label className="form-label mb-0 w-20">Peer Reviewer</label>
              <Select
                className="custom-checkbox-select"
                // value={props.value}
                // value={""} /
                options={UserOption}

              // onChange={props.onChange}
              // onBlur={props.onBlur}
              // options={props.options}
              // isMulti={props.isMultiSelect}
              // placeholder={props.placeholder}
              // isDisabled={props.isDropdownDisabled}
              />

            </div>
            <div className="d-flex align-items-center">
              <label className="form-label mb-0 w-20">Approver</label>
              <Select
                className="custom-checkbox-select"
                // value={props.value}
                // value={""} /
                options={UserOption}

              // onChange={props.onChange}
              // onBlur={props.onBlur}
              // options={props.options}
              // isMulti={props.isMultiSelect}
              // placeholder={props.placeholder}
              // isDisabled={props.isDropdownDisabled}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Save"
              buttonTypeClassName="search-btn"
            // onClick={handleCombine}
            // isLoading={isChangeKeyPosition}
            // isDisable={isChangeKeyPosition}
            />
            <div className="d-flex gap-3">
              <Buttons
                buttonText="Approve"
                buttonTypeClassName="success-btn"
              // onClick={handleCombine}
              // isLoading={isChangeKeyPosition}
              // isDisable={isChangeKeyPosition}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateGroupingListApprove;
